/**
 * Domain-owned type aliases. These currently delegate to `@packages/clients` because the domain has no reason to
 * diverge. The alias pattern (rather than bare re-export) ensures we can replace any of these with a custom
 * definition without affecting consumers. Trade-off: upstream API changes propagate automatically, but this is
 * preferable to maintaining duplicate definitions preemptively.
 */
import {
    AssetMediaType as AssetMediaTypeDto,
    AssetProcessingState as AssetProcessingStateDto,
    AssetType as AssetTypeDto,
} from '@packages/clients';

/** The media variant of an asset (file, original, thumbnail, etc.). */
export const AssetMediaType = AssetMediaTypeDto;
/** The media variant of an asset (file, original, thumbnail, etc.). */
export type AssetMediaType = AssetMediaTypeDto;

/** The processing state of an asset during and after upload. */
export const AssetProcessingState = AssetProcessingStateDto;
/** The processing state of an asset during and after upload. */
export type AssetProcessingState = AssetProcessingStateDto;

/** The high-level type of an asset (video, image, or generic file). */
export const AssetType = AssetTypeDto;
/** The high-level type of an asset (video, image, or generic file). */
export type AssetType = AssetTypeDto;
